<div class="languages" dropdown dropdownOpenClass="is-open">
  <div class="languages__current" dropdownToggle>
    <div class="flag flag_{{ currentLocale | localeFlag }}"></div>
    <div class="languages__current-name">
      {{ LOCALE_NAMES[currentLocale] }}
    </div>

    <div class="icon icon_new icon_triangleDown !text-[1.4rem]"></div>
  </div>

  <div class="languages__list !z-[999]" dropdownContent>
    <div class="languages__scroll" scroll="vertical">
      @if (currentPath$ | async; as currentPath) {
        @for (locale of supportedLocales; track locale) {
          <a
            class="languages__item link group !custom-transition-all"
            [href]="generateLocaleUrl(locale, currentPath)"
            [hreflang]="locale"
            [class.is-active]="locale === currentLocale"
            (click)="changeLocale(locale)"
          >
            @if (locale === 'ru' && showCisFlag) {
              <img class="h-[1.8rem] w-[1.8rem]" src="/assets/images/language/cis.svg" />
            } @else {
              <div class="flag flag_{{ locale | localeFlag }} group-hover:ml-[0.4rem] custom-transition-all"></div>
            }
            <div class="flag__name">
              {{ LOCALE_NAMES[locale] }}
            </div>
          </a>
        }
      }
    </div>
  </div>
</div>
